









































































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'

import polygon from '@/service/430527.json'
import preColors from './json/pre_colors.json'
import temColors from './json/tem_colors.json'

import buttonGroup from './button_group.vue'
import filterCondition from './filter_condition.vue'
import colorGroup from './color_group.vue'
import tableView from './table_view.vue'

import MapService from '@/service/MapService'

import * as L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import {LMap, LFeatureGroup, LTileLayer, LPolygon, LImageOverlay, LMarker, LIcon, LGeoJson, LPopup} from 'vue2-leaflet'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
L.Icon.Default.imagePath = 'leaflet/dist/images/'
const options = {
    subdomains: [0, 1, 2, 3, 4, 5, 6, 7],
    key: '3ea5ad4a3c9e978735800163ef36217a',
}
export default Vue.extend({
    components: {
        LMap,
        LFeatureGroup,
        LTileLayer,
        LPolygon,
        LImageOverlay,
        LMarker,
        LIcon,
        LGeoJson,
        'v-marker-cluster': Vue2LeafletMarkerCluster,
        LPopup,
        buttonGroup,
        filterCondition,
        colorGroup,
        tableView,
        // tileLayerChange,
    },
    data() {
        return {
            zoom: 9.2,
            center: [config.defaultStationObj.lat, config.defaultStationObj.lon],
            option: {
                zoomSnap: 0.2, attributionControl: false, zoomControl: false,
                dragging: true, scrollWheelZoom: true,
            },
            flag: 0,
            options,
            url1: 'http://t{s}.tianditu.com/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk={key}',
            url2: 'http://t{s}.tianditu.com/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk={key}',
            url3: 'http://t{s}.tianditu.com/DataServer?T=img_w&X={x}&Y={y}&L={z}&tk={key}',
            url4: 'http://t{s}.tianditu.com/DataServer?T=cia_w&X={x}&Y={y}&L={z}&tk={key}',
            polygon: [] as any,
            barId: '',
            mapTitle: ''as any,
            timeStr: '',
            initData: [],
            checkConditionObj: {
                check: false,
                data: {}as any,
            },
            beforeMapData: [],
            mapData: [],
            showSpin: true,
            colors: [] as any,
            geojson: {} as any,
            isColor: false,
            fillColorShow: true,
            isTableShow: false,
        }
    },
    created() {
        // console.log(this.$route.params)
        this.barId = this.$route.params.id
        document.title = this.getWindowTitle(this.barId) as any
        polygon.map((e: any) => {
            this.polygon.push([e[1], e[0]])
        })
        if (this.barId === 'pre' || this.barId === 'tem') {
            this.fillColorShow = true
        } else {
            this.fillColorShow = false
        }
        this.mapTitle = this.getMapTitle(this.barId)
    },
    methods: {
        changeBar(value: any) {
            this.showSpin = true
            this.colors = []
            this.geojson = {}
            this.initData = []
            this.barId = value
            if (this.barId === 'pre' || this.barId === 'tem') {
                this.fillColorShow = true
            } else {
                this.fillColorShow = false
                this.isColor = false
            }
            this.mapTitle = this.getMapTitle(this.barId)
        },
        getData(value: any) {
            // console.log(value)
            this.colors = []
            this.geojson = {}
            this.timeStr = value.timeStr
            this.initData = JSON.parse(JSON.stringify(value.data))
            this.checkCondition(this.checkConditionObj)
        },
        async checkCondition(value: any) {
            // console.log(value)
            this.checkConditionObj = value
            const arr = JSON.parse(JSON.stringify(this.initData))
            let newData = []
            const {check, data} = this.checkConditionObj
            if (check) {
                if (data.value.length === 2) {
                    newData = arr.filter((i: any) => {
                        return i.level === data.value[0] || i.level === data.value[1]
                    })
                } else if (data.tag === '>=') {
                    if (this.barId === 'wind') {
                        newData = arr.filter((i: any) => {
                            return i.level >= data.value
                        })
                    } else {
                        newData = arr.filter((i: any) => {
                            return i.value >= data.value
                        })
                    }
                } else if (data.tag === '<=') {
                    if (this.barId === 'wind') {
                        newData = arr.filter((i: any) => {
                            return i.level <= data.value
                        })
                    } else {
                        newData = arr.filter((i: any) => {
                            return i.value <= data.value
                        })
                    }
                }
            } else {
                newData = arr
            }
            // console.log(newData)
            this.beforeMapData = newData
            this.mapData = JSON.parse(JSON.stringify(newData))
            this.getMapColor()
        },
        fillColor() {
            this.showSpin = true
            this.colors = []
            this.geojson = {}
            // this.$nextTick()
            this.isColor = !this.isColor
            this.getMapColor()
        },
        async getMapColor() {
            const data = JSON.parse(JSON.stringify(this.beforeMapData))
            if (this.isColor === true) {
                this.colors = await MapService.getColorJson(this.barId)
                this.geojson = await MapService.getGeoJson(this.mapData, this.barId)
                this.mapData.map((e: any) => {
                    if (e.bgColor) {
                        e.bgColor = '#00BFFF'
                    }
                })
            } else {
                this.colors = []
                this.geojson = {}
                this.mapData = data
            }
            this.showSpin = false
        },
        styleFunction() {
            return (feature: any) => {
                const colorJson: any[] = this.colors
                const lvalue = feature.properties.lvalue
                let color = '0,0,0,0'
                for (const item of colorJson) {
                    if (item.length < 5) {
                        continue
                    }
                    if (lvalue < item[1]) {
                        color = item[2] + ',' + item[3] + ',' + item[4]
                        break
                    }
                }
                if (color === '0,0,0') {
                    // color = '154, 154, 154'
                    color = '0,0,0,0'
                }
                // if (color === '255,255,255') {
                //     color = '0, 0, 0, 0.1'
                // }
                return {
                    radius: 100,
                    fillColor: 'rgb(' + color + ')',
                    color: 'rgb(' + color + ')',
                    // weight: 0,
                    // fillOpacity: 0.8,
                    weight: 1,
                    fillOpacity: 1,
                }
            };
        },
        showTable(value: any) {
            this.isTableShow = value
        },
        markerChange(mapObj: any) {
            // console.log(mapObj.latlng.lat)
            // console.log(mapObj.latlng.lng)
        },
        getMapTitle(value: any) {
            if (value === 'tem') {
                return '气温图'
            } else if (value === 'pre') {
                return '降水图'
            } else if (value === 'wind') {
                return '风速风向图'
            } else if (value === 'rhu') {
                return '湿度图'
            }
        },
        getWindowTitle(value: any) {
            if (value === 'tem') {
                return '气温监测'
            } else if (value === 'pre') {
                return '降水监测'
            } else if (value === 'wind') {
                return '风速风向'
            } else if (value === 'rhu') {
                return '相对湿度'
            }
        },
    },
})
